import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Container, Title, Text, Button, Stack } from '@mantine/core';
import { House } from '@phosphor-icons/react';
import AnimatedLogo from '../components/AnimatedLogo';
import SEO from '../components/SEO';

export default function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-[#F6F5F4] flex flex-col items-center justify-center px-4">
      <SEO title={t('notFound.seoTitle')} noIndex />
      <Stack align="center" gap="md">
        <AnimatedLogo size={64} />
        <Text fz={120} fw={900} c="gray.2" lh={1}>
          404
        </Text>
        <Title order={2}>
          {t('notFound.title')}
        </Title>
        <Text c="dimmed" ta="center" maw={400}>
          {t('notFound.description')}
        </Text>
        <Button
          component={Link}
          to="/"
          size="md"
          radius="md"
          leftSection={<House size={18} />}
          mt="sm"
        >
          {t('notFound.backHome')}
        </Button>
      </Stack>
    </div>
  );
}
